module.exports = __webpack_public_path__ + "static/img/AM3.3f8dee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/AM3.jpg
// module id = aUC6
// module chunks = 1